import React from "react";
import {useLocation} from "react-router-dom";
import {useFormikContext} from "formik";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";
import NationalLifeIncome
    from "../../../pages/client/Enrollment/EnrollmentHome/basicInfo/ProfileFormFields/IndividualIncome";
import AllianzIncome
    from "../../../pages/client/Enrollment/allianzAppHome/basicInfo/ProfileFormFields/IndividualIncome";
import CommonFieldFunction from "../../../pages/client/Enrollment/EnrollmentHome/basicInfo/CommonFieldFunction";
import {noop} from "../../../utils/commonUtils";
import {AllianzLifeCarrierDetail, NationalLifeCarrierDetail} from "../../../constants";


type CarrierBasedIncomeProps = {
    isAgentGWT: boolean
}

const CarrierBasedIncome = ({isAgentGWT}) => {
    const {values, touched, errors, handleChange, handleBlur, setFieldValue}: any = useFormikContext();
    const location = useLocation();
    const authUser = useSelector((state: RootState) => state.auth);
    const clientDetail = useSelector((state: RootState) => state.clientAccount);
    const isGiftorPage = location.pathname.includes('/giftor-details');
    const user = isGiftorPage ? clientDetail : authUser.user;
    const clientPolicy = user && user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
    const primaryCarrier = values.primaryCarrier || (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id);

    const CommonField = (filedProps: any, action: any) => {
        return (
                <CommonFieldFunction
                        action={action}
                        client={user && user.client}
                        clientSigned={clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned}
                        conditionalRequired={true}
                        filedProps={filedProps}
                        getFieldFocusValue={noop}
                        labelsActive={[]}
                        role={user.role}
                        setActionItem={noop}
                        setLabelsActive={noop}
                />
        )
    };

    const props = {
        CommonField,
        conditionalRequired: true,
        currentlyEmployed: "yes",
        errors: errors,
        financiallyDependent: false,
        gwtV2FD: false,
        handleBlur: handleBlur,
        handleChange: handleChange,
        isGiftorAgentInvite: isAgentGWT,
        isGiftorPortal: true,
        isGWTGenV2: false,
        setFieldValue: setFieldValue,
        touched: touched,
        values: values,
    };

    switch (primaryCarrier) {
        case NationalLifeCarrierDetail.id:
            return <NationalLifeIncome {...props} />;
        case AllianzLifeCarrierDetail.id:
            return <AllianzIncome {...props} />;
        default:
            return null;
    }
};

export default CarrierBasedIncome;